<template>
    <div>
      <b-form-row v-if="notEmptyObject(this)">
        <b-col cols="2">
          <b-form-group id="inputTelefonoFijo-group" label="Teléfono(s) :" label-for="inputTelefonoFijo">
            <b-form-input id="inputTelefonoFijo" type="text" v-model="this.personal.InformacionPersonal.Telefono" readonly/>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group id="inputEmail-group" label="Correo Electrónico : " label-for="inputEmail">
            <b-form-input id="inputEmail" type="email" v-model="this.personal.InformacionPersonal.Email" readonly/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group id="inputDomicilio-group" label="Domicilio :" label-for="inputDomicilio">
            <b-form-input id="inputDomicilio" type="text" v-model="this.personal.InformacionPersonal.Domicilio" readonly/>
          </b-form-group>
        </b-col>
      </b-form-row>
    </div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
export default {
    name: 'CardDatosContacto',
    mixins: [errorhandler, swalerts],
    props: {
        personal: Object,
    },
  data() {
    return {}
  },
  methods:{
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/CardDatosContacto.vue